<template>
	<div v-if="dataList && dataList.length > 0" class="measurement-indicators">
		<!--  section header  -->
		<div v-if="dataList" class="section-header">
			<div class="hollow_circle"></div>
			<span class="main-title">测量指标</span>
			<span class="sub-title">/ Measurement indicators</span>
		</div>

		<HealthyMeasureChartsCardItem 
			v-for="(item, index) in dataList || []"
			:key="index"
			:type="item.item"
			:echartId="'HealthyMeasureChartsCard-' + item.item" 
			:option="getChartOption(item)"
			:model="item"
		/>

	</div>
	<div v-else></div>
</template>

<script>
import * as echarts from 'echarts';
import HealthyMeasureChartsCardItem from './HealthyMeasureChartsCardItem.vue';
import getEchartOptionMeasure1 from '../../chartOptions/echartOptionMeasure1';

export default {
	name: 'MeasurementIndicators',
	components: {
		HealthyMeasureChartsCardItem
	},
	props: {
		bedId: {
			type: Number,
			required: true,
			default: 0
		},
		date: {
			type: String,
			required: true,
			default: ''
		},
		activeType: {
			type: Number,
			required: true,
			default: 3
		},
  },
	created() {
		this.getMeasuresData();
	},
	mounted() {
		
	},
	data() {
    return {
      dataList: null
    };
  },
	methods: {
		reloadData() {
			this.getMeasuresData();
		},
		// 获取当日测量情况
    getMeasuresData(){
			this.dataList = null;
			let params = {
				bedId: this.$props.bedId,
				date: this.$props.date,
				healthTrendsDays: this.$props.activeType == 4 ? 30 : 7
			}
      this.$get(
        'api/measure/measureItemDetailsList',
        params,
        (res) => {
          if (res.code === 0) {
            if (res.data) {
							this.dataList = res.data;
						} else {
						}
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
		getChartOption(model) {

			// 1.获取图表类型
			let type = this.$lodash.get(model, 'item', [] ) !== null ? this.$lodash.get(model, 'item', [] ) : [];

			// 2.正常范围
			let normal_range = [];
			let normal_range_2 = null;
			if (type === 'oxygenSaturation') normal_range = [95, 100];
			if (type === 'pulseRate') normal_range = [40, 100];
			if (type === 'bloodPressure') {
				normal_range = [90, 139];
				normal_range_2 = [60, 89];
			};
			if (type === 'bodyTemperature') normal_range = [0, 37.5];

			// 3.正常区域
			let mark_area = { // 收缩压和其他
				silent: true,
				itemStyle: {
          color: 'rgba(24, 144, 255, 0.1)',
					opacity: 0.06
        },
			};
			let mark_area_2 = { // 舒张压
				silent: true,
				itemStyle: {
          color: 'rgba(195, 148, 254, 0.1)',
					opacity: 0.07
        },
			};
			if (type === 'bloodPressure') {
				mark_area.data = [[{yAxis: normal_range[0]}, {yAxis: normal_range[1]}]];
				mark_area_2.data = [[{yAxis: normal_range_2[0]}, {yAxis: normal_range_2[1]}]];
			} else {
				mark_area.data = [[{yAxis: normal_range[0]}, {yAxis: normal_range[1]}]];
			}

			// X轴数据
			let xAxis_data = this.$lodash.get(model, 'xaxis', [] ) !== null ? this.$lodash.get(model, 'xaxis', [] ) : [];
			
			// Series Data
			let series = [];

			let tempDatas = this.$lodash.get(model, 'data', [] ) !== null ? this.$lodash.get(model, 'data', [] ) : []
			let serveDatas = JSON.parse(JSON.stringify(tempDatas));
			for (let i = 0; i < serveDatas.length; i ++) {

				let item = serveDatas[i];

				let series_item = {
					type: 'line',
					lineStyle: {
						width: 1,
						color: 'rgba(24, 144, 255, 1)'
					},
					symbol: 'circle',
					symbolSize: 6,
					itemStyle: {
						color: 'rgba(24, 144, 255, 1)'
					}
				};

				let series_item_2 = {
					type: 'line',
					lineStyle: {
						width: 1,
						color: 'rgba(24, 144, 255, 1)'
					},
					symbol: 'circle',
					symbolSize: 6,
					itemStyle: {
						color: 'rgba(24, 144, 255, 1)'
					}
				};

				if (type === 'bloodPressure') {
					series_item.lineStyle.type = 'dashed'
				}

				let series_item_data = []

				let series_item_data_2 = [];

				if (item) {
					for (let j = 0; j < item.length; j++) {
						let subItem = item && item[j] ? JSON.parse(JSON.stringify(item[j])) : {};
						let subItem_2 = item && item[j] ? JSON.parse(JSON.stringify(item[j])) : {};

						subItem.fType = type;
						subItem_2.fType = type;

						if (type === 'bloodPressure') { // 血压
							// 判断是否为正常值
							let dict = {value: subItem.itemValueAvg, extra: subItem, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem.itemAbnormalAvg == 1) {
								dict.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							dict.extra.sType = 'systolicBloodPressure';

							// 判断是否为正常值
							let dict_2 = {value: subItem_2.itemValue2Avg, extra: subItem_2, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem_2.itemAbnormal2Avg == 1) {
								dict_2.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							dict_2.extra.sType = 'diastolicBloodPressure';

							series_item_data.push(dict);
							series_item_data_2.push(dict_2);
						} else {
							// 判断是否为正常值
							let dict = {value: subItem.itemValueAvg, extra: subItem, itemStyle: {color: 'rgba(24, 144, 255, 1)'}};
							if (subItem.itemAbnormalAvg == 1) {
								dict.itemStyle.color = 'rgba(255, 113, 134, 1)';
							}
							series_item_data.push(dict);
						}
					}
				} else {
					series_item_data.push(null);
					series_item_data_2.push(null);
				}
				series_item.data = series_item_data;

				series_item.markArea = mark_area;

				series.push(series_item);

				if (type === 'bloodPressure') {
					series_item_2.data = series_item_data_2;

					series_item_2.markArea = mark_area_2;

					series.push(series_item_2);
				}
			}


			// 最小值
			let minValue = type === 'oxygenSaturation' ? 70 : type === 'pulseRate' ? 40 : type === 'bloodPressure' ? 50 : 30
		
			return getEchartOptionMeasure1(
				{
					xAxis_data: xAxis_data,
					series: series,
					extends_data: tempDatas
				}, minValue
			);
		}
	},
	beforeDestroy() {
		
	},
};
</script>

<style lang="scss" scoped>
.measurement-indicators {
	margin-top: 20px;
	font-family: 'Microsoft Yahei', sans-serif;

	.section-header {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		.hollow_circle {
			width: 19px;
			height: 19px;
			border: 4px solid #1890FF;
			border-radius: 50%;
			margin-right: 16px;
		}

		.main-title {
			font-family: PingFangSC, PingFang SC;
			font-weight: 600;
			font-size: 24px;
			color: #1F2635;
			line-height: 33px;
			margin-right: 10px;
		}

		.sub-title {
				font-size: 16px;
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
				color: #cacdd9;
		}
	}
}
</style>